import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const LogsRoute = lazyWithRetries(() => import('.'))
const SecurityLogsRoute = lazyWithRetries(() => import('./SecurityLogs'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.admin.logs(),
    element: (
      <Suspense fallback={<RouteLoading />}>
        <LogsRoute />
      </Suspense>
    ),
  },
  {
    path: AppPaths.tenant.admin.securityLogs(),
    element: (
      <StandardPageLayout
        maxWidth={1440}
        elementId="securityLogsRoute"
        title={<T _str="Security logs" />}>
        <Suspense fallback={<RouteLoading />}>
          <SecurityLogsRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
